import classNames from 'classnames';
import { FC, memo } from 'react';

import { getMascotImageSrc } from '@gem/utils';

import { ChatBackgroundPattern as ChatBackgroundPatternEnum } from 'APP/constants/appearance';

import styles from './ChatBackgroundPattern.styles.m.css';

export const CHAT_IMAGE_MAP: { [key in ChatBackgroundPatternEnum]?: string } = {
  [ChatBackgroundPatternEnum.Brand]: 'chat-background-pattern-brand.svg',
  [ChatBackgroundPatternEnum.Dusk]: 'chat-background-pattern-dusk.svg',
  [ChatBackgroundPatternEnum.Breeze]: 'chat-background-pattern-breeze.svg',
  [ChatBackgroundPatternEnum.Bloom]: 'chat-background-pattern-bloom.svg',
};

interface IChatBackgroundPatternProps {
  pattern: ChatBackgroundPatternEnum;
  maskPosition?: string;
  maskSize?: string;
  className?: string;
}

export const ChatBackgroundPattern: FC<IChatBackgroundPatternProps> = memo(
  ({ pattern, maskPosition, maskSize, className }) => {
    const imageUrl = getMascotImageSrc(CHAT_IMAGE_MAP[pattern] || '');

    return (
      <div className={classNames(styles.container, className)}>
        {!!imageUrl && (
          <div
            className={styles.backgroundImage}
            style={{
              WebkitMaskImage: `url(${imageUrl})`,
              maskImage: `url(${imageUrl})`,
              maskPosition,
              maskSize,
            }}
          />
        )}
      </div>
    );
  }
);
